import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const BranchSelect = ({ branchRef }) => {
  return (
    <FormControl fullWidth required>
      <Select
        name="military"
        inputRef={branchRef}
        defaultValue=""
        size="small"
        sx={{background:"white"}}
        displayEmpty
      >
        <MenuItem value="">-- Please Choose an Option --</MenuItem>
        <MenuItem value="Marine Corps">Marine Corps</MenuItem>
        <MenuItem value="Army">Army</MenuItem>
        <MenuItem value="Navy">Navy</MenuItem>
        <MenuItem value="Air Force">Air Force</MenuItem>
        <MenuItem value="Coast Guard">Coast Guard</MenuItem>
        <MenuItem value="Space Force">Space Force</MenuItem>
        <MenuItem value="National Guard">National Guard</MenuItem>
      </Select>
    </FormControl>
  );
};

export default BranchSelect;
